
<template>

  <div class="lotti-therapist-module">
    <div class="lotti-therapist-name">{{ auth.user.profile.firstName }} {{ auth.user.profile.lastName }}</div>
    <div class="lotti-therapist-email">{{ auth.user.profile.email }}</div>

    <table class="lotti-therapist-info">
      <tr>
        <td class="lotti-therapist-info-title">Dienst</td>
        <td class="lotti-therapist-info-data">{{ auth.user.profile.serviceName }}</td>
      </tr>
      <tr>
        <td class="lotti-therapist-info-title">Pensum</td>
        <td class="lotti-therapist-info-data">{{ infoData.pensum }}</td>
      </tr>
      <tr>
        <td class="lotti-therapist-info-title">WochenSoll</td>
        <td class="lotti-therapist-info-data">{{ infoData.weeklyValue }}</td>
      </tr>
    </table>

  </div>

</template>

<script>
import auth from '../../auth.js';
import Vue from "../../main";

export default {

  data() {
    return {
      auth: auth,

      infoData: {
        pensum: '%',
        weeklyValue: 'min'
      }
    }
  },

  methods: {
    getMyPensum() {
      Vue.http.get(
          'api/v1/therapist/get-my-pensum'
      ).then(response => {
        this.infoData.pensum = response.data.pensum + '%';
        this.infoData.weeklyValue = response.data.weekly_minutes + ' min';
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },
  },

  beforeMount() {

    //get pensum data of therapist
    this.getMyPensum();
  },
  mounted() {

  }
}

</script>